import { Fragment, useEffect, useState, useRef, useCallback } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import close from '../../assets/images/model/close.png';
import { useParams } from 'react-router-dom';

import './createbook.css';
import './createbookresponsive.css';
import { single } from '../../Store/api/books';
import { useDispatch, useSelector } from 'react-redux';
import { byBook, deleteChapter } from '../../Store/api/activities';
import RightBar from '../../components/RightBar';
import { setOpenActivity } from '../../Store/ui/reader';
import {
  setActivities as setReduxActivities,
  setBook as setReduxBook,
  setChapters,
  bookActions,
} from '../../Store/entities/book';
import {
  createChapter,
  createSection,
  createParagraph,
  reOrderChapters,
  reOrderSections,
  savedLastVisitBook,
  deleteBlock,
  reOrderParagraph,
  deleteParagraph,
} from '../../Store/api/create';
import { TextEditorFun } from '../../components/createmode/TextEditorFun';
import debouncer from '../../services/debouncer';
import { CustomModal } from '../../shared/CustomModal';
import { ModalPortal } from '../../components/ModalPortal';
import SideBar from './SideBar';
import Chapter from './elements/Chapter';
import { changeChapter } from '../../Store/api/bookSection';
import { changeParents } from '../../Store/api/paragraphs';
import { toast } from 'react-toastify';

export const CreateNewBookPage = () => {
  const dispatch = useDispatch();

  // const { book: bookFromState } = useSelector((state) => state.entities);
  const { reader } = useSelector((state) => state.ui.reader);
  const { loaders } = useSelector((state) => state.ui);
  const { chapter, section } = reader;
  const { settings } = useSelector((state) => state.settings.settings);
  const [addTextBook, setAddTextBook] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [chapterId, setChapterId] = useState(null);
  const [book, setBook] = useState({ book: {}, chapters: [], activities: [] });
  const [activities, setActivities] = useState([]);
  const { bookId } = useParams();
  const [isClicked, setIsClicked] = useState(false);
  const [isSelectedOption, setIsSelectedOption] = useState('chapter');
  const [isDraggingFromLeft, setIsDraggingFromLeft] = useState(false);
  const [currentTab, setCurrentTab] = useState('content');
  /* Dragging in Center Fold */
  const [highlightedSection, setHighlightedSection] = useState(null);
  const [highlightedSections, setHighlightedSections] = useState([]);
  const [greyedItem, setGreyedItem] = useState('');
  const [draggedOver, setDraggedOver] = useState(null);
  const [highlightedIndexes, setHighlightedIndexes] = useState([]);
  const [draggedChap, setDraggedChap] = useState('');
  const [pTop, setPtop] = useState(0);
  const [outlineHeight, setOutlineHeight] = useState(0);
  const [isResizing, setIsResizing] = useState(false);
  const [isResizingUp, setIsResizingUp] = useState(true);
  const [greyedParagraphs, setGreyedPharagraphs] = useState([]);
  const [highlightedParagraph, setHighlightedParagraph] = useState(null);
  const [creatingActivity, setCreatingActivity] = useState(undefined);
  const [writingActivity, setWritingActivity] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [reverse, setReverse] = useState(false);
  const [selectedParagraphs, setSelectedParagraphs] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);
  const [visibleSection, setVisibleSection] = useState(false);
  const [isSections, setIsSections] = useState(false);
  const [activeIds, setActiveIds] = useState([]);
  const [currentChapterId, setCurrentChapterId] = useState(null);
  const [editingOptions, setEditingOptions] = useState({});
  const dropdownRef = useRef(null);
  const [activeChapter, setActiveChapter] = useState(null);
  const [draggedType, setDraggedType] = useState('');
  const [newActivities, setNewActivities] = useState([]);
  const [activityElement, setActivityElement] = useState(null);
  const [isErrored, setIsErrored] = useState(false);
  const [removeItemDetails, setRemoveItemDetails] = useState({
    route: '',
    id: '',
    chapterIndex: -1,
    sectionIndex: -1,
    paragraphIndex: -1,
  });
  const [draggedOverElement, setDraggedOverElement] = useState('');
  const [showBlock, setShowBlock] = useState('');
  const [mediaList, setMediaList] = useState([]);
  const rightBarRef = useRef(null);
  const [visibleElements, setVisibleElements] = useState({
    chapterOrder: null,
    sectionOrder: null,
  });
  const handleVisibilityChange = (chapterOrder, sectionOrder) => {
    setVisibleElements({ chapterOrder, sectionOrder });
  };

  const mediaIdList = mediaList
    ?.filter((list) => ['image', 'video', 'audio'].includes(list.type) && list.url === '')
    .map((list) => list._id);

  const { activities: actsFromRedux } = useSelector((state) => state.entities.book.book);

  const [editorState, setEditorState] = useState({
    currentState: [],
    currentStateIndex: -1,
    fontFamily: 'Inter, sans-serif',
    content: 'Hey there',
    originalContent: '',
    formatting: {
      bold: false,
      italic: false,
      underline: false,
      bullets: false,
      orders: false,
      link: false,
      align: 'left',
      fontSize: 3,
    },
  });

  useEffect(() => {
    setBook((old) => ({ ...old, activities: actsFromRedux }));
    setActivities(actsFromRedux);
  }, [actsFromRedux]);

  useEffect(() => {
    dispatch(bookActions.setMyBook(book));
  }, [book, dispatch]);

  useEffect(() => {
    return () => {
      if (mediaIdList.length > 0) {
        dispatch(
          deleteParagraph({
            body: { mediaIds: mediaIdList },
            onSuccess: (res) => {},
            onError: (error) => {
              console.error('Delete paragraph failed:', error);
            },
          })
        );
      }
    };
  }, [mediaIdList]);

  useEffect(() => {}, [reader]);
  useEffect(() => {
    if (bookId) {
      dispatch(savedLastVisitBook({ bookId: bookId }));
    }
    return () => {};
  }, [bookId]);

  const editableElementRef = useRef({});
  const toggleCollapse = (id) => {
    setActiveIds((prevActiveIds) => {
      const updatedActiveIds = prevActiveIds.includes(id)
        ? prevActiveIds.filter((activeId) => activeId !== id)
        : [...prevActiveIds, id];
      return updatedActiveIds;
    });
    setActiveChapter((prevActiveChapter) => {
      const newActiveChapter = prevActiveChapter === id ? null : id;
      return newActiveChapter;
    });
  };

  const handleChapterSelect = (chapterId) => {
    const div = document.getElementById(chapterId);
    if (div) div.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setScrollToId(chapterId);
    setCurrentChapterId(chapterId);
  };

  const handleDragEndAccordion = (result) => {
    if (!result.destination) {
      return;
    }
    const chaptersNew = JSON.parse(JSON.stringify(book.chapters));
    const chapters = reorder(chaptersNew, result.source.index, result.destination.index);
    dispatch(
      reOrderChapters({
        body: { chapters: chapters.map((e) => e._id), book: bookId },
        onSuccess: (res) => {},
        onError: (err) => {},
      })
    );
    setBook((old) => ({ ...old, chapters: chapters }));
    dispatch(bookActions.setMyBook({ ...book, chapters: chapters }));
  };
  const handleDragLeave = useCallback(
    debouncer(() => {
      setDraggedOverElement('');
    }, 300),
    []
  );

  // Function to handle drag and drop for main content
  const handleDragEndChapters = (result) => {
    handleDragLeave();
    setDraggedType('');
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;

    if (result.type === 'chapter') {
      // Reorder chapters
      const newChapters = reorder(book.chapters, source.index, destination.index);
      dispatch(
        reOrderChapters({
          body: { chapters: newChapters.map((e) => e._id), book: bookId },
          onSuccess: (res) => {},
          onError: (err) => {},
        })
      );
      setBook((old) => ({ ...old, chapters: newChapters }));
      dispatch(bookActions.setMyBook({ ...book, chapters: newChapters }));
    } else if (result.type === 'section') {
      const sourceChapterIndex = parseInt(source.droppableId.split('_')[1]);
      const destinationChapterIndex = parseInt(destination.droppableId.split('_')[1]);

      if (sourceChapterIndex === destinationChapterIndex) {
        // Reorder sections within the chapter
        const newChaptersSelect = [...book.chapters];
        const chapter = newChaptersSelect[sourceChapterIndex];

        if (!chapter || !chapter.sections) {
          console.error('Chapter or sections are undefined');
          return;
        }

        const newSections = reorder(chapter.sections, source.index, destination.index);
        newChaptersSelect[sourceChapterIndex] = {
          ...chapter,
          sections: newSections,
        };
        dispatch(
          reOrderSections({
            body: {
              book: bookId,
              chapter: chapter._id,
              sections: newSections.map((e) => e._id),
            },
            onSuccess: (res) => {},
            onError: (err) => {},
          })
        );
        setBook((old) => ({ ...old, chapters: newChaptersSelect }));
      } else {
        // Handle drag and drop between different chapters
        const newChaptersSelect = JSON.parse(JSON.stringify(book.chapters));

        // Get source and destination chapters
        const sourceChapter = newChaptersSelect[sourceChapterIndex];
        const destinationChapter = newChaptersSelect[destinationChapterIndex];
        if (
          !sourceChapter ||
          !destinationChapter ||
          !sourceChapter.sections ||
          !destinationChapter.sections
        ) {
          console.error('Chapters or sections are undefined');
          return;
        }
        // Remove the section from the source chapter
        const [removedSection] = sourceChapter.sections.splice(source.index, 1);
        // Add the section to the destination chapter at the specified position
        destinationChapter.sections.splice(destination.index, 0, removedSection);
        // Update both chapters in the array
        newChaptersSelect[sourceChapterIndex] = {
          ...sourceChapter,
          sections: [...sourceChapter.sections],
        };

        newChaptersSelect[destinationChapterIndex] = {
          ...destinationChapter,
          sections: [...destinationChapter.sections],
        };

        // First change the section chapter through changeChapter, and then reorder the destination to make the accurate order
        dispatch(
          changeChapter({
            body: { chapter: newChaptersSelect[destinationChapterIndex]._id },
            id: removedSection._id,
            onSuccess: () => {
              dispatch(
                reOrderSections({
                  body: {
                    book: bookId,
                    chapter: destinationChapter._id,
                    sections: destinationChapter.sections.map((e) => e._id),
                  },
                  onSuccess: (res) => {
                    dispatch(
                      byBook({
                        id: bookId,
                        onSuccess: () => {},
                      })
                    );
                  },
                  onError: (err) => {},
                })
              );
            },
          })
        );
        setBook((old) => ({ ...old, chapters: newChaptersSelect }));
      }
    } else if (result.type === 'paragraph') {
      // Paragraph reordering is not included in MVP
      const sourceChapterIndex = parseInt(source.droppableId.split('_')[1]);
      const destinationChapterIndex = parseInt(destination.droppableId.split('_')[1]);
      const sourceSectionIndex = parseInt(source.droppableId.split('_')[2]);
      const destinationSectionIndex = parseInt(destination.droppableId.split('_')[2]);
      if (
        sourceChapterIndex === destinationChapterIndex &&
        sourceSectionIndex === destinationSectionIndex
      ) {
        const newChaptersSelect = JSON.parse(JSON.stringify(book.chapters));
        const chapter = newChaptersSelect[sourceChapterIndex];

        if (!chapter || !chapter.sections) {
          console.error('Chapter or sections are undefined');
          return;
        }
        const section = chapter.sections[sourceSectionIndex];

        const newParas = reorder(section.paragraphs, source.index, destination.index);
        const newSections = [...chapter.sections];
        newSections[sourceSectionIndex].paragraphs = newParas;
        newChaptersSelect[sourceChapterIndex] = {
          ...chapter,
          sections: newSections,
        };
        dispatch(
          reOrderParagraph({
            body: {
              book: bookId,
              chapter: chapter._id,
              section: section._id,
              paragraghs: newParas.map((e) => e._id),
            },
            onSuccess: (res) => {},
            onError: (err) => {},
          })
        );
        setBook((old) => ({ ...old, chapters: newChaptersSelect }));
      } else if (
        sourceChapterIndex === destinationChapterIndex &&
        sourceSectionIndex !== destinationSectionIndex
      ) {
        const newChaptersSelect = JSON.parse(JSON.stringify(book.chapters));
        const chapter = newChaptersSelect[sourceChapterIndex];

        if (!chapter || !chapter.sections) {
          console.error('Chapter or sections are undefined');
          return;
        }

        const sourceSection = chapter.sections[sourceSectionIndex];
        const destinationSection = chapter.sections[destinationSectionIndex];

        // Remove paragraph from source section
        const [movedParagraph] = sourceSection.paragraphs.splice(source.index, 1);

        // Add to destination section
        destinationSection.paragraphs.splice(destination.index, 0, movedParagraph);

        dispatch(
          changeParents({
            id: movedParagraph?._id,
            body: {
              section: destinationSection?._id,
              chapter: chapter._id,
            },
            onSuccess: () => {
              dispatch(
                reOrderParagraph({
                  body: {
                    book: bookId,
                    chapter: chapter._id,
                    section: destinationSection._id,
                    paragraghs: destinationSection.paragraphs.map((e) => e._id),
                  },
                  onSuccess: (res) => {},
                  onError: (err) => {},
                })
              );
              dispatch(
                reOrderParagraph({
                  body: {
                    book: bookId,
                    chapter: chapter._id,
                    section: sourceSection._id,
                    paragraghs: sourceSection.paragraphs.map((e) => e._id),
                  },
                  onSuccess: (res) => {},
                  onError: (err) => {},
                })
              );
            },
          })
        );

        setBook((old) => ({
          ...old,
          chapters: newChaptersSelect,
          activities: old.activities?.map((act) =>
            act.paragraphs.includes(movedParagraph._id)
              ? {
                  ...act,
                  paragraphs: act.paragraphs.filter((p) => p !== movedParagraph._id),
                }
              : act
          ),
        }));
      } else {
        //handle when both chapter and  section are diff
        const newChaptersSelect = JSON.parse(JSON.stringify(book.chapters));
        const sourceChapter = newChaptersSelect[sourceChapterIndex];
        const destinationChapter = newChaptersSelect[destinationChapterIndex];

        if (
          !sourceChapter ||
          !destinationChapter ||
          !sourceChapter.sections ||
          !destinationChapter.sections
        ) {
          console.error('Chapters or sections are undefined');
          return;
        }

        const sourceSection = sourceChapter.sections[sourceSectionIndex];
        const destinationSection = destinationChapter.sections[destinationSectionIndex];

        // Remove paragraph from source section
        const [movedParagraph] = sourceSection.paragraphs.splice(source.index, 1);

        // Update paragraph's chapter reference
        movedParagraph.chapter = destinationChapter._id;

        // Add to destination section
        destinationSection.paragraphs.splice(destination.index, 0, movedParagraph);

        dispatch(
          changeParents({
            id: movedParagraph?._id,
            body: {
              section: destinationSection?._id,
              chapter: destinationChapter._id,
            },
            onSuccess: () => {
              dispatch(
                reOrderParagraph({
                  body: {
                    book: bookId,
                    chapter: destinationChapter._id,
                    section: destinationSection._id,
                    paragraghs: destinationSection.paragraphs.map((e) => e._id),
                  },
                  onSuccess: (res) => {},
                  onError: (err) => {},
                })
              );
              dispatch(
                reOrderParagraph({
                  body: {
                    book: bookId,
                    chapter: sourceChapter._id,
                    section: sourceSection._id,
                    paragraghs: sourceSection.paragraphs.map((e) => e._id),
                  },
                  onSuccess: (res) => {},
                  onError: (err) => {},
                })
              );
            },
          })
        );

        setBook((old) => ({
          ...old,
          chapters: newChaptersSelect,
          activities: old.activities?.map((act) =>
            act.paragraphs.includes(movedParagraph._id)
              ? {
                  ...act,
                  paragraphs: act.paragraphs.filter((p) => p !== movedParagraph._id),
                }
              : act
          ),
        }));

        // setBook((old) => ({ ...old, chapters: newChaptersSelect }));
      }
    }
  };

  const setEditableElement = (event, options = {}) => {
    if (event.target.tagName === 'A') {
      window.open(event.target.href, '_blank');
    }
    if (
      Object.keys(editableElementRef.current).length > 0 &&
      editingOptions.elementId === options.elementId &&
      editingOptions.field === options.field
    )
      return;
    editableElementRef.current = event.currentTarget;

    setEditingOptions(options);
  };

  const setDocumentFocus = () => editableElementRef.current.focus();

  const handleTopDrop = (e) => {
    setDraggedOverElement('');
    setDraggedType('');
    const type = e.dataTransfer.getData('type');
    if (type === 'chapter') {
      dispatch(
        createChapter({
          body: {
            book: bookId,
            order: 1,
            title: 'Chapter Header',
            description: 'Chapter description',
          },
          onSuccess: (res) => {
            setBook((old) => {
              const chapters = [...old.chapters];
              const newChapters = [res.data.data, ...chapters];
              return {
                ...old,
                chapters: newChapters,
              };
            });
            setScrollToId(res.data.data._id);
            newId.current = res.data.data._id;
          },
        })
      );
    }
  };
  const handleChapterDrop = (e, chap, chapInd) => {
    // e.preventDefault();
    e.stopPropagation();
    setDraggedOverElement('');
    setDraggedType('');
    const type = e.dataTransfer.getData('type');
    switch (type) {
      case 'chapter':
        dispatch(
          createChapter({
            body: {
              book: bookId,
              order: chap.order + 1,
              title: 'Chapter Header',
              description: 'Chapter description',
            },
            onSuccess: (res) => {
              setBook((old) => {
                const chapters = [...old.chapters];
                const newChapters = [
                  ...chapters.slice(0, chapInd + 1),
                  res.data.data,
                  ...chapters.slice(chapInd + 1),
                ];
                return {
                  ...old,
                  chapters: newChapters,
                };
              });
              setScrollToId(res.data.data._id);
              newId.current = res.data.data._id;
            },
          })
        );
        break;
      case 'section':
        dispatch(
          createSection({
            onSuccess: (res) => {
              dispatch(
                createParagraph({
                  body: {
                    chapter: chap._id,
                    section: res.data.data._id,
                    text: 'Add text to your paragraph',
                    book: bookId,
                  },
                  onSuccess: (para) => {
                    setBook((old) => {
                      const newChapters = JSON.parse(JSON.stringify(old.chapters));
                      newChapters[chapInd].sections = [
                        ...newChapters[chapInd].sections,
                        { ...res.data.data, paragraphs: [para.data.data] },
                      ];
                      return { ...old, chapters: newChapters };
                    });
                    newId.current = `${chap._id}.${res.data.data._id}`;
                  },
                })
              );
              setScrollToId(res.data.data._id);
              newId.current = res.data.data._id;
            },
            onError: (err) => {},
            body: {
              chapter: chap._id,
              title: 'Section Header',
              book: bookId,
            },
          })
        );
        break;
      case 'paragraph':
        dispatch(
          createSection({
            onSuccess: (res) => {
              dispatch(
                createParagraph({
                  body: {
                    order: 1,
                    chapter: chap._id,
                    section: res.data.data._id,
                    text: 'Start typing your section',
                    book: bookId,
                  },
                  onSuccess: (para) => {
                    setBook((old) => {
                      const newChapters = JSON.parse(JSON.stringify(old.chapters));
                      newChapters[chapInd].sections = [
                        { ...res.data.data, paragraphs: [para.data.data] },
                        ...newChapters[chapInd].sections,
                      ];
                      return { ...old, chapters: newChapters };
                    });
                    newId.current = `${chap._id}.${res.data.data._id}`;
                  },
                })
              );
              setScrollToId(res.data.data._id);
              newId.current = res.data.data._id;
            },
            onError: (err) => {},
            body: {
              order: 1,
              chapter: chap._id,
              title: 'Section Header',
              book: bookId,
            },
          })
        );

        break;
      case 'small_header':
        dispatch(
          createSection({
            onSuccess: (res) => {
              dispatch(
                createParagraph({
                  body: {
                    order: 1,
                    chapter: chap._id,
                    section: res.data.data._id,
                    text: "<span style='font-size: 20px;'><b>Small Header</b></span> ",
                    type: 'small_header',
                    book: bookId,
                  },
                  onSuccess: (para) => {
                    setBook((old) => {
                      const newChapters = JSON.parse(JSON.stringify(old.chapters));
                      newChapters[chapInd].sections = [
                        { ...res.data.data, paragraphs: [para.data.data] },
                        ...newChapters[chapInd].sections,
                      ];
                      return { ...old, chapters: newChapters };
                    });
                    newId.current = `${chap._id}.${res.data.data._id}`;
                  },
                })
              );
              setScrollToId(res.data.data._id);
              newId.current = res.data.data._id;
            },
            onError: (err) => {},
            body: {
              order: 1,
              chapter: chap._id,
              title: 'Section Header',
              book: bookId,
            },
          })
        );

        break;
      case 'activity':
        dropCard(e.dataTransfer.getData('template'), chap._id, '', [], 'chapter');
        break;
      default:
        break;
    }
  };

  // Add Chapter Block Click Handler
  const handleAddChapterBlock = (chaptrOrder = -1, chapInd) => {
    const insertIndex = chaptrOrder === -1 ? chapInd + 1 : chapInd + 2;
    dispatch(
      createChapter({
        body: {
          book: bookId,
          title: 'Chapter Header',
          description: 'Chapter description',
          order: insertIndex,
        },
        onSuccess: (res) => {
          setBook((old) => ({
            ...old,
            chapters: res.data?.data?.chapters || [],
          }));
          newId.current = res.data.data._id;
          setScrollToId(res.data.data._id);
          setCurrentChapterId(res.data.data._id);
        },
        onError: (err) => {
          toast.error(
            err?.response?.data?.message ||
              err?.response?.data?.data?.message ||
              err?.data?.data?.message ||
              err?.message ||
              'Error while add Chapter block.'
          );
        },
      })
    );
  };

  // Add Section Block Click Handler
  const handleAddSectionBlock = (sectionOrder = -1, sectionInd, chap) => {
    const insertIndex = sectionOrder === -1 ? sectionInd + 1 : sectionInd + 2;
    dispatch(
      createSection({
        body: {
          chapter: chap._id,
          title: 'Section Header',
          book: bookId,
          order: insertIndex,
        },
        onSuccess: (res) => {
          dispatch(
            createParagraph({
              body: {
                chapter: chap._id,
                section: res.data.data._id,
                text: 'Add text to your paragraph',
                book: bookId,
              },
              onSuccess: (response) => {
                setBook((old) => ({
                  ...old,
                  chapters: response.data?.data?.chapters || [],
                }));
                newId.current = `${chap._id}.${res.data.data._id}`;
              },
            })
          );
          setScrollToId(res.data.data._id);
          newId.current = res.data.data._id;
        },
        onError: (err) => {
          toast.error(
            err?.response?.data?.message ||
              err?.response?.data?.data?.message ||
              err?.data?.data?.message ||
              err?.message ||
              'Error while add Section block.'
          );
        },
      })
    );
  };

  // Add paragraph/small_header/audio/video/image without section
  const handleAddChapterSubBlock = (chap, order = 1, type) => {
    dispatch(
      createSection({
        body: {
          order,
          chapter: chap._id,
          title: 'Section Header',
          book: bookId,
        },
        onSuccess: (res) => {
          dispatch(
            createParagraph({
              body: {
                order: 1,
                chapter: chap._id,
                section: res.data.data._id,
                ...(type === 'small_header'
                  ? {
                      text: "<span style='font-size: 20px;'><b>Small Header</b></span> ",
                      type: 'small_header',
                    }
                  : {
                      text: 'Add text to your paragraph',
                    }),
                book: bookId,
              },
              onSuccess: (response) => {
                setBook((old) => ({
                  ...old,
                  chapters: response.data?.data?.chapters || [],
                }));
                newId.current = `${chap._id}.${res.data.data._id}`;
              },
            })
          );
          setScrollToId(res.data.data._id);
          newId.current = res.data.data._id;
        },
        onError: (err) => {
          toast.error(
            err?.response?.data?.message ||
              err?.response?.data?.data?.message ||
              err?.data?.data?.message ||
              err?.message ||
              'Error while add block.'
          );
        },
      })
    );
  };

  // Add Small Header Block Click Handler
  const handleAddSmallHeaderBlock = (order = -1, paraIndex, chap, sectionId, type) => {
    const insertIndex = order === -1 ? paraIndex + 1 : paraIndex + 2;

    dispatch(
      createParagraph({
        body: {
          chapter: chap._id,
          section: sectionId,
          ...(type === 'small_header'
            ? {
                text: "<span style='font-size: 20px;'><b>Small Header</b></span> ",
                type: 'small_header',
              }
            : {
                text: 'Add text to your paragraph',
              }),
          book: bookId,
          order: insertIndex,
        },
        onSuccess: (res) => {
          setBook((old) => ({
            ...old,
            chapters: res.data?.data?.chapters || [],
          }));
          setScrollToId(res.data.data._id);
          newId.current = `${chap._id}.${sectionId}.${res.data.data._id}`;
        },
        onError: (err) => {
          toast.error(
            err?.response?.data?.message ||
              err?.response?.data?.data?.message ||
              err?.data?.data?.message ||
              err?.message ||
              'Error while add Small Header block.'
          );
        },
      })
    );
  };

  // Add Media Block Click Handler
  const handleAddMediaBlock = (order = -1, paraIndex, chap, sectionId, mediaType) => {
    dispatch(
      createParagraph({
        body: {
          chapter: chap._id,
          section: sectionId,
          book: bookId,
          title: '',
          text: '',
          order: order === -1 ? paraIndex + 1 : paraIndex + 2,
          media: [
            {
              type: mediaType,
              url: '',
              alt: '',
              attribution: '',
            },
          ],
        },
        onSuccess: (res) => {
          setBook((old) => ({
            ...old,
            chapters: res.data?.data?.chapters || [],
          }));
          setScrollToId(res.data.data._id);
          dispatch(
            bookActions.setMyBook({
              ...book,
              chapters: res.data?.data?.chapters || [],
            })
          );
        },
        onError: (err) => {
          toast.error(
            err?.response?.data?.message ||
              err?.response?.data?.data?.message ||
              err?.data?.data?.message ||
              err?.message ||
              'Error while add Media block.'
          );
        },
      })
    );
  };

  const dropCard = (template, chapter, section, paragraphs = [], elementType, sections = []) => {
    setDraggedChap(`${chapter}.${section}`);

    if (paragraphs.length > 0 && elementType === 'paragraph') {
      setIsSections(false);
      setDraggedOver(null);
      setHighlightedIndexes(paragraphs);
      const element = document.getElementById(paragraphs[0]);

      setPtop(element.offsetTop);
    } else if (sections.length > 0 && elementType === 'section') {
      setIsSections(true);
      setDraggedOver(null);
      setHighlightedIndexes(sections);
      const element = document.getElementById(sections[0]);

      setPtop(element.offsetTop);
    }
    setNewActivities([
      {
        book: bookId,
        id: Date.now(),
        element: {
          index:
            paragraphs.length > 0 && elementType === 'paragraph'
              ? `${chapter}.${section}.${paragraphs[0].split('.')[0]}`
              : section !== ''
              ? `${chapter}.${section}`
              : chapter,
          type: elementType,
        },
        title: '',
        description: '',
        score: '',
        isShared: false,
        type: template,

        questions: [
          {
            type: template,
            text: '',
            description: '',
            score:
              template === 'mcqs'
                ? 1
                : template === 'truefalse'
                ? 0.5
                : template === 'fr'
                ? 3
                : template === 'sa'
                ? 1.5
                : template === 'blanks'
                ? 0.5
                : 0.25,
            difficulty: 1,
            options:
              template === 'truefalse'
                ? [
                    {
                      type: 'text',
                      text: 'True',
                      isCorrect: false,
                    },
                    {
                      type: 'text',
                      text: 'False',
                      isCorrect: false,
                    },
                  ]
                : template === 'mcqs'
                ? []
                : [],
            sentence: '',
            blanksBank: [],
            bankQuestion: [],
            mediaList: [],
          },
        ],
      },
    ]);
    setActivityElement({
      index:
        paragraphs.length > 0 && elementType === 'paragraph'
          ? `${chapter}.${section}.${paragraphs[0].split('.')[0]}`
          : section !== ''
          ? `${chapter}.${section}`
          : chapter,
      type: elementType,
    });
    setDragging(false);
    setWritingActivity(true);
  };

  const handleSectionDrop = (e, chap, chapInd, section, secIndex) => {
    // e.preventDefault();
    e.stopPropagation();
    e.preventDefault();
    setDraggedOverElement('');
    setDraggedType('');
    const type = e.dataTransfer.getData('type');
    switch (type) {
      case 'chapter':
        dispatch(
          createChapter({
            body: {
              book: bookId,
              order: chap.order + 1,
              title: "<span style='font-size: 20px;'><b>Chapter title</b></span>",
              description: 'Chapter description',
            },
            onSuccess: (res) => {
              setBook((old) => {
                const chapters = [...old.chapters];
                const newChapters = [
                  ...chapters.slice(0, chapInd + 1),
                  res.data.data,
                  ...chapters.slice(chapInd + 1),
                ];
                return {
                  ...old,
                  chapters: newChapters,
                };
              });
              setScrollToId(res.data.data._id);
              newId.current = res.data.data._id;
            },
          })
        );
        break;
      case 'section':
        dispatch(
          createSection({
            onSuccess: (res) => {
              dispatch(
                createParagraph({
                  body: {
                    chapter: chap._id,
                    section: res.data.data._id,
                    text: 'Add text to your paragraph',
                    book: bookId,
                  },
                  onSuccess: (para) => {
                    setBook((old) => {
                      const newChapters = JSON.parse(JSON.stringify(old.chapters));
                      const sections = JSON.parse(JSON.stringify(newChapters[chapInd].sections));
                      const newSections = [
                        ...sections.slice(0, secIndex + 1),
                        { ...res.data.data, paragraphs: [para.data.data] },
                        ...sections.slice(secIndex + 1),
                      ];
                      newChapters[chapInd].sections = newSections;
                      return { ...old, chapters: newChapters };
                    });
                    newId.current = `${chap._id}.${res.data.data._id}`;
                  },
                })
              );
            },
            onError: (err) => {},
            body: {
              chapter: chap._id,
              title: 'Section title',
              book: bookId,
              order: section.order ? section.order : 1,
            },
          })
        );
        break;
      case 'paragraph':
        dispatch(
          createParagraph({
            onSuccess: (res) => {
              setBook((old) => {
                const newChapters = JSON.parse(JSON.stringify(old.chapters));

                newChapters[chapInd].sections[secIndex].paragraphs.unshift(res.data.data);
                return { ...old, chapters: newChapters };
              });
              setScrollToId(res.data.data._id);
              newId.current = `${chap._id}.${section._id}.${res.data.data._id}`;
            },
            onError: (err) => {},
            body: {
              chapter: chap._id,
              section: section._id,
              text: 'Add text to the paragraph ',
              type: 'paragraph',
              book: bookId,
              order: 1,
            },
          })
        );

        break;
      case 'small_header':
        dispatch(
          createParagraph({
            onSuccess: (res) => {
              setBook((old) => {
                const newChapters = JSON.parse(JSON.stringify(old.chapters));

                newChapters[chapInd].sections[secIndex].paragraphs.unshift(res.data.data);
                return { ...old, chapters: newChapters };
              });
              setScrollToId(res.data.data._id);
              newId.current = `${chap._id}.${section._id}.${res.data.data._id}`;
            },
            onError: (err) => {},
            body: {
              chapter: chap._id,
              section: section._id,
              text: "<span style='font-size: 20px;'><b>Small Header</b></span> ",
              type: 'small_header',
              book: bookId,
              order: 1,
            },
          })
        );

        break;

      case 'activity':
        dropCard(e.dataTransfer.getData('template'), chap._id, section._id, [], 'section', [
          `${chap._id}.${section._id}`,
        ]);
        break;
      default:
        break;
    }
  };
  const handleParagraphDrop = (e, chap, chapInd, section, secIndex, paragraph, index) => {
    e.preventDefault();
    e.stopPropagation();
    setDraggedOverElement('');
    setDraggedType('');
    const type = e.dataTransfer.getData('type');
    let invalid = true;
    const body = {
      chapter: chap._id,
      section: section._id,
      book: bookId,
      title: '',
      text: '',
      order: paragraph.order ? paragraph.order + 1 : 1,
      media: [
        {
          type: 'image',
          url: '',
          alt: '',
          attribution: '',
        },
      ],
    };
    switch (type) {
      case 'image':
        body.media[0].type = 'image';
        invalid = false;
        break;
      case 'video':
        body.media[0].type = 'video';
        invalid = false;
        break;
      case 'audio':
        body.media[0].type = 'audio';
        invalid = false;
        break;
      case 'paragraph':
        body.media = [];
        body.text = 'Add text to the paragraph';
        invalid = false;
        break;
      case 'small_header':
        body.media = [];
        body.text = "<span style='font-size: 20px;'><b>Small Header</b></span> ";
        invalid = false;
        break;
      case 'section':
        dispatch(
          createSection({
            onSuccess: (res) => {
              dispatch(
                createParagraph({
                  body: {
                    chapter: chap._id,
                    section: res.data.data._id,
                    text: 'Start typing your section',
                    book: bookId,
                  },
                  onSuccess: (para) => {
                    setBook((old) => {
                      const newChapters = JSON.parse(JSON.stringify(old.chapters));
                      const sections = JSON.parse(JSON.stringify(newChapters[chapInd].sections));
                      const newSections = [
                        ...sections.slice(0, secIndex + 1),
                        { ...res.data.data, paragraphs: [para.data.data] },
                        ...sections.slice(secIndex + 1),
                      ];
                      newChapters[chapInd].sections = newSections;
                      return { ...old, chapters: newChapters };
                    });
                    newId.current = `${chap._id}.${res.data.data._id}`;
                  },
                })
              );
            },
            onError: (err) => {},
            body: {
              chapter: chap._id,
              title: 'Section title',
              book: bookId,
              order: section.order ? section.order : 1,
            },
          })
        );
        break;
      case 'chapter':
        dispatch(
          createChapter({
            body: {
              book: bookId,
              order: chap.order + 1,
              title: "<span style='font-size: 20px;'><b>Chapter title</b></span>",
              description: 'Chapter description',
            },
            onSuccess: (res) => {
              setBook((old) => {
                const chapters = [...old.chapters];
                const newChapters = [
                  ...chapters.slice(0, chapInd + 1),
                  res.data.data,
                  ...chapters.slice(chapInd + 1),
                ];
                return {
                  ...old,
                  chapters: newChapters,
                };
              });
              setScrollToId(res.data.data._id);
              newId.current = res.data.data._id;
            },
          })
        );
        break;

      case 'activity':
        dropCard(
          e.dataTransfer.getData('template'),
          chap._id,
          section._id,
          [`${chap._id}.${section._id}.${paragraph._id}`],
          'paragraph'
        );
        break;
      default:
        break;
    }
    if (invalid) return;
    dispatch(
      createParagraph({
        onSuccess: (res) => {
          if (res.data.data.book === bookId) {
            setMediaList((prevParagraphs) => [...prevParagraphs, ...res.data.data.media]);
          }

          setBook((old) => {
            const newChapters = JSON.parse(JSON.stringify(old.chapters));
            const sectPs = newChapters[chapInd].sections[secIndex].paragraphs;

            // Perform the splice operation directly on sectPs
            sectPs.splice(index + 1, 0, { ...res.data.data });
            return { ...old, chapters: newChapters };
          });
          const newChapters = JSON.parse(JSON.stringify(book.chapters));
          const sectPs = newChapters[chapInd].sections[secIndex].paragraphs;

          // Perform the splice operation directly on sectPs
          sectPs.splice(index + 1, 0, { ...res.data.data });
          dispatch(bookActions.setMyBook({ ...book, chapters: newChapters }));
          setScrollToId(res.data.data._id);
          if (type === 'paragraph' || type === 'small_header') {
            newId.current = `${chap._id}.${section._id}.${res.data.data._id}`;
          }
        },
        onError: (err) => {
          toast.error(
            err?.response?.data?.message ||
              err?.response?.data?.data?.message ||
              err?.data?.data?.message ||
              err?.message ||
              'Error while add Media block.'
          );
        },
        body,
      })
    );
  };
  /* .............End............. */

  const handleAddParagraph = (chap, section, chapInd, secIndex) => {
    dispatch(
      createParagraph({
        onSuccess: (res) => {
          setBook((old) => {
            const newChapters = JSON.parse(JSON.stringify(old.chapters));

            newChapters[chapInd].sections[secIndex].paragraphs.push(res.data.data);
            return { ...old, chapters: newChapters };
          });
          setScrollToId(res.data.data._id);
          newId.current = `${chap._id}.${section._id}.${res.data.data._id}`;
        },
        onError: (err) => {},
        body: {
          chapter: chap._id,
          section: section._id,
          text: 'Add text to the paragraph',
          book: bookId,
        },
      })
    );
  };

  /* ----------------End----------------- */

  // Reorder function
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  /* ......................... */

  const handleAddSection = (chapterId, order = null) => {
    const chapInd = book.chapters.findIndex((chap) => chap._id === chapterId);
    const body = {
      chapter: chapterId,
      title: 'Section Header',
      book: bookId,
    };
    if (order) body.order = order;
    dispatch(
      createSection({
        onSuccess: (res) => {
          dispatch(
            createParagraph({
              body: {
                chapter: chapterId,
                section: res.data.data._id,
                text: 'Start typing your section',
                book: bookId,
              },
              onSuccess: (para) => {
                setBook((old) => {
                  if (order) {
                    const newChapters = JSON.parse(JSON.stringify(book.chapters));
                    const sections = JSON.parse(JSON.stringify(newChapters[chapInd].sections));
                    const newSections = [
                      ...sections.slice(0, order - 1),
                      { ...res.data.data, paragraphs: [para.data.data] },
                      ...sections.slice(order - 1),
                    ];
                    newChapters[chapInd].sections = newSections;
                    return { ...old, chapters: newChapters };
                  } else {
                    const newChapters = JSON.parse(JSON.stringify(old.chapters));
                    newChapters[chapInd].sections = [
                      ...newChapters[chapInd].sections,
                      { ...res.data.data, paragraphs: [{ ...para.data.data }] },
                    ];

                    return { ...old, chapters: newChapters };
                  }
                });
              },
            })
          );

          setScrollToId(res.data.data._id);
          newId.current = `${chapterId}.${res.data.data._id}`;
          setActiveIds((prevActiveIds) => {
            const updatedActiveIds = prevActiveIds.includes(chapterId)
              ? prevActiveIds
              : [...prevActiveIds, chapterId];
            return updatedActiveIds;
          });
        },
        body,
        onError: (err) => {},
      })
    );
  };

  const handleAddSectionClick = (fromSideBar = false) => {
    if (!fromSideBar) {
      const lastChapterId = book.chapters[book.chapters.length - 1]._id;
      handleAddSection(lastChapterId);
    } else {
      if (currentChapterId) {
        handleAddSection(currentChapterId);
      } else if (book.chapters.length > 0) {
        // Add to the last chapter if no chapter is selected
        const lastChapterId = book.chapters[book.chapters.length - 1]._id;
        handleAddSection(lastChapterId);
      } else {
        alert('Please create a chapter first.');
      }
    }
  };

  useEffect(() => {
    const div = document.getElementById('dragged_indicator');
    if (div) {
      div.scrollIntoView({ block: 'nearest' });
    }
  }, [draggedOverElement]);

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setCreatingActivity(undefined);
      dispatch(setOpenActivity({}));
    }
    return () => {
      dispatch(setOpenActivity({}));
    };
  }, [bookId, dispatch]);

  const newId = useRef(null);
  useEffect(() => {
    if (newId.current) {
      const el = document.getElementById(newId.current);
      if (el) {
        const editableElement = el.querySelector('.editable-element');

        if (editableElement) {
          editableElement.click();
          editableElement.focus();
          const range = document.createRange();
          range.selectNodeContents(editableElement);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
      newId.current = null;
    }
  }, [book]);

  const handleAddChapter = () => {
    dispatch(
      createChapter({
        body: {
          title:
            "<span style='font-size: 32px; font-weight: 700; font-family: Inter;'> Chapter header </span>",
          description: 'Chapter description',
          book: bookId,
          title: 'Chapter Header',
          description: 'Chapter description',
        },
        onSuccess: (res) => {
          setBook((old) => ({
            ...old,
            chapters: [...old.chapters, { ...res.data.data }],
          }));
          newId.current = res.data.data._id;
          setScrollToId(res.data.data._id);
          setCurrentChapterId(res.data.data._id);
        },
        onError: (err) => {},
      })
    );
  };

  /* ___________________________End_____________________________________ */

  const handleDragOver = (e, id = '', chapter = '', section = '', paragraph = '', from = '') => {
    e.stopPropagation();
    e.preventDefault();
    if (!id) return;
    if (draggedType === 'activity') {
      if (paragraph !== '') {
        setDraggedOver({
          index: `${chapter}.${section}.${paragraph}`,
          type: 'paragraph',
        });
      } else if (section !== '') {
        setDraggedOver({ index: `${chapter}.${section}`, type: 'section' });
      } else if (chapter && !paragraph && !section) {
        setDraggedOver({ index: chapter, type: 'chapter' });
      }
    } else {
      setDraggedOverElement(
        from === draggedType || (from === 'paragraph' && draggedType === 'small_header')
          ? id
          : from === 'section' && draggedType === 'chapter'
          ? chapter
          : from === 'chapter' && draggedType === 'section'
          ? chapter
          : from === 'paragraph' && draggedType === 'section'
          ? section
          : from === 'section' && (draggedType === 'paragraph' || draggedType === 'small_header')
          ? section
          : from === 'paragraph' && draggedType === 'chapter'
          ? chapter
          : id
      );
    }
  };

  /* --------------------------------------------------------------- */

  const [scrollToId, setScrollToId] = useState(null);
  useEffect(() => {
    if (scrollToId) {
      const div = document.getElementById(scrollToId);

      if (div) {
        div.scrollIntoView({ block: 'start', behavior: 'smooth' });
        // setScrollToId(null);
      }
    }
  }, [scrollToId]);

  const scrollTo = (activity, open = false) => {
    if (activity === null) {
      setDraggedOver(null);
      setHighlightedIndexes([]);
      setHighlightedSections([]);
      setGreyedPharagraphs([]);
      setHighlightedSection(null);
      setDraggedChap('');
      setGreyedItem('');
    } else {
      if (
        (!activity.sections || activity?.sections?.length === 0) &&
        activity.paragraphs?.length === 0
      ) {
        if (open) setDraggedOver({ index: activity.chapter, type: 'chapter' });
        setHighlightedIndexes([]);
        setDraggedChap('');
      } else if (activity?.sections?.length > 0 && activity?.paragraphs?.length === 0) {
        setHighlightedSections(activity.sections);
        if (open) setIsSections(true);
        setDraggedOver(null);
        if (open) setHighlightedIndexes(activity.sections.map((s) => `${activity.chapter}.${s}`));
        setDraggedChap(`${activity.chapter}.${activity.section}`);
      } else {
        setDraggedOver(null);
        setIsSections(false);
        setHighlightedSection('');
        setHighlightedSections([]);
        if (open)
          setHighlightedIndexes(
            activity.paragraphs.map((p) => `${activity.chapter}.${activity.section}.${p}`)
          );
        setDraggedChap(`${activity.chapter}.${activity.section}`);
      }
      let greyedId = activity.chapter;
      let setId = activity.chapter;
      if (activity?.sections?.length > 0) {
        greyedId = activity?.sections?.[0];
        setId += `.${activity?.sections?.[0]}`;
      }
      if (activity.paragraphs && activity.paragraphs.length) {
        setGreyedPharagraphs(activity.paragraphs);
        greyedId = '';
        setId += `.${activity.section}.${activity.paragraphs[0]}`;
      }
      setGreyedItem(greyedId);
      setScrollToId(setId);
      const div = document.getElementById(setId);
      if (div) {
        const rect = div.getBoundingClientRect();

        const isCentered = !(rect.top < 100 || rect.top > window.innerHeight - 60);
        if (!isCentered) {
          div.scrollIntoView({ block: 'start' });
          // setTimeout(() => {
          scrollerRef.current.scrollTop -= 10;
          // }, 600);
        }
      }
    }
  };
  const highlightSection = (e, value) => {
    setGreyedItem('');
    if (highlightedSections.includes(value)) {
      setHighlightedSections([]);
      setActivities(book.activities);
    } else {
      if (creatingActivity) return;
      setHighlightedSections([value]);
      setActivities(
        book.activities.filter((e) => e?.sections?.includes(value) && e.paragraphs.length === 0)
      );
      // setScrollToId(value);
    }
  };

  const scrollerRef = useRef(null);
  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  const addTextBookButton = () => {
    setAddTextBook(true);
  };
  //Load Book
  useEffect(() => {
    dispatch(
      single({
        id: bookId,
        onSuccess: (res) => {
          if (!res.data.data) {
          } else {
            dispatch(setReduxBook(res.data.data.book));
            dispatch(setChapters(res.data.data.chapters));
            setBook((old) => {
              return {
                ...old,
                book: res.data.data.book,
                chapters: res.data.data.chapters,
              };
            });
          }
        },
        onError: (error) => {},
      })
    );
  }, [bookId, dispatch]);

  useEffect(() => {
    dispatch(
      byBook({
        id: bookId,
        onSuccess: (res) => {
          setActivities(res.data.data);
          dispatch(setReduxActivities(res.data.data));
          setBook((old) => {
            return { ...old, activities: res.data.data };
          });
        },
        onError: (error) => {},
      })
    );
  }, [bookId, dispatch]);

  const dynamicSectionStyles = (chap, section) => {
    let className = 'section_element unique_section';
    className += settings.fontLarge ? ' fontLarge' : '';
    className +=
      highlightedSection === `${section._id}` || greyedItem === section._id ? ' highlighted' : '';
    className += highlightedSections.includes(section._id) ? ' highlighted' : '';
    className +=
      draggedOver &&
      draggedOver.type === 'section' &&
      draggedOver.index === `${chap._id}.${section._id}`
        ? ' trigger'
        : '';
    className += highlightedIndexes?.includes(`${chap._id}.${section._id}`)
      ? ' activated_s_tags'
      : '';

    return className;
  };

  const resizingSet = (value, up, e) => {
    setIsResizing(value);
    setIsResizingUp(up);
  };
  const reverseIt = (e) => {
    setReverse(!reverse);
  };

  const dynamicPStyles = (chap, section, paragraph) => {
    let className = 'theme_para_se paragraph_element main_p';

    className +=
      book.activities.findIndex((e) => e.paragraphs.includes(paragraph._id)) > -1 ? ' rich' : '';
    className += settings.fontLarge ? ' fontLarge' : '';
    className +=
      highlightedParagraph === paragraph._id || greyedParagraphs.includes(paragraph._id)
        ? ' bg_grey'
        : '';

    return className;
  };

  const handleResizing = (e) => {
    if (!isResizing && !dragging && !draggedType) return;
    // const newHeight = isResizingUp? outlineHeight - e.movementY : outlineHeight + e.movementY;
    const container = scrollerRef.current;
    const containerHeight = container.clientHeight;
    const scrollHeight = container.scrollHeight;
    const scrollTop = container.scrollTop;
    let additionalHeight = 0;
    const dx = isResizing ? 50 : 200;
    // Check if the mouse movement is towards the bottom
    if (e.clientY > containerHeight - 100) {
      // Check if the content is not already scrolled to the bottom
      if (scrollTop < scrollHeight - containerHeight) {
        // Scroll the content further down by adding a small amount to scrollTop
        container.scrollTop += 5;
        additionalHeight += 10;
      }
    } else if (e.clientY < 150) {
      // Check if the mouse movement is towards the top
      // Check if the content is not already scrolled to the top
      if (scrollTop > 0) {
        // Scroll the content further up by subtracting a small amount from scrollTop
        container.scrollTop -= 5;
        additionalHeight -= 7;
      }
    }
    setOutlineHeight(
      isResizingUp
        ? outlineHeight - e.movementY - additionalHeight
        : outlineHeight + e.movementY + additionalHeight
    );
    setPtop(isResizingUp ? pTop + e.movementY + additionalHeight : pTop);
  };

  const calculateTotalHeight = () => {
    let totalHeight = 0;
    let top = Infinity;
    const pElements = document.getElementsByClassName(
      isSections ? 'activated_s_tags' : 'activated_p_tags'
    );

    if (pElements.length > 0) {
      for (let i = 0; i < pElements.length; i++) {
        totalHeight += pElements[i].offsetHeight;
      }
      top = Math.min(top, pElements[0].offsetTop);

      setPtop(top);
    }

    return totalHeight;
  };
  useEffect(() => {
    // let totalHeight = 0;
    // let top = Infinity;
    // const pElements = document.getElementsByClassName(
    //   isSections ? "activated_s_tags" : "activated_p_tags"
    // );

    // if (pElements.length > 0) {
    //   for (let i = 0; i < pElements.length; i++) {
    //     totalHeight += pElements[i].offsetHeight;
    //   }
    //   top = Math.min(top, pElements[0].offsetTop);

    //   setPtop(top);
    // }

    setOutlineHeight(calculateTotalHeight());
  }, [highlightedIndexes, isSections]);

  let timerId = useRef(null);
  useEffect(() => {
    const outlineComponent = document.getElementById('outline_component');

    if (!outlineComponent) return;

    timerId.current = setTimeout(() => {
      let prevParagraph;
      let paragraphs = [];
      let sectionPasses = false;
      let firstParagraphPasses = false;
      let currentSection = draggedChap.split('.')[1];
      if (isSections) {
        currentSection = draggedChap.split('.')[0];
      }
      const draggedSec = document.getElementById(draggedChap);
      const dragged_chap = document.getElementById(draggedChap?.split('.')?.[0]);
      const chapBottom = dragged_chap.getBoundingClientRect().bottom;
      const secBottom = draggedSec.getBoundingClientRect().bottom;
      const pElements = document.getElementsByClassName(
        isSections ? 'unique_section' : 'unique_paragraph'
      );
      const { offsetTop: fTop } = pElements[0];
      const { top: outlineTop, bottom } = outlineComponent.getBoundingClientRect();
      //snap back the top to first paragraph of the selected section if it exceeds the section from the top
      if (pTop < fTop) {
        for (let j = 0; j < pElements.length; j++) {
          const {
            offsetTop,
            dataset: { secid: secidj },
          } = pElements[j];
          if (secidj === currentSection) {
            setIsErrored(true);
            const diff = offsetTop - pTop;
            if (!isResizing) {
              setPtop(offsetTop);
              setOutlineHeight((prev) => prev - diff);
            }
            return;
          } else {
            setIsErrored(false);
          }
        }
        return;
      }

      for (let i = 0; i < pElements.length; i++) {
        const {
          offsetTop,
          dataset: { id, secid },
        } = pElements[i];
        const { top, bottom: pBottom } = pElements[i].getBoundingClientRect();

        if (
          (outlineTop <= top && top <= bottom) ||
          (top <= outlineTop && outlineTop <= pBottom) ||
          (top <= bottom && bottom <= pBottom)
        ) {
          const mid = top + (pBottom - top) / 2;

          if (secid === currentSection) {
            sectionPasses = true;
            prevParagraph = pElements[i];
          } else if (prevParagraph) {
            //snap back the bottom to bottom of the last paragraph of the selected section if it exceeds the section from bottom
            const { bottom: pBottom } = prevParagraph.getBoundingClientRect();

            if (bottom > pBottom) {
              // setIsErrored(true);
              if (!isResizing) {
                setPtop(pTop);
                setOutlineHeight((prev) => prev - (bottom - pBottom));
              }
              return;
            } else {
              // setIsErrored(false);
            }
          }
          if (bottom > secBottom && !isSections) {
            setIsErrored(true);
            if (!isResizing) setOutlineHeight((prev) => prev - (bottom - secBottom));
            return;
          } else if (isSections && bottom > chapBottom) {
            setIsErrored(true);
            if (!isResizing) setOutlineHeight((prev) => prev - (bottom - chapBottom));
            return;
          } else {
            setIsErrored(false);
          }

          if (secid !== currentSection) {
            // Paragraph of other sections
            if (!sectionPasses) {
              // current section not passed yet and other section paragraph is in selection then find first paragraph of current section

              for (let j = i; j < pElements.length; j++) {
                const {
                  offsetTop,
                  dataset: { secid: secidj },
                } = pElements[j];
                if (secidj === currentSection) {
                  // setIsErrored(true);
                  const diff = offsetTop - pTop;
                  if (!isResizing) {
                    setPtop(offsetTop);
                    setOutlineHeight((prev) => prev - diff);
                  }
                  return;
                } else {
                  setIsErrored(false);
                }
              }
            } else {
              // current section has passed and other section paragraph is in selection then find previous paragraph of current section

              const { bottom: pBottom } = prevParagraph.getBoundingClientRect();
              // setIsErrored(true);
              if (!isResizing) {
                setPtop(pTop);
                setOutlineHeight((prev) => prev - (bottom - pBottom) - 10);
              }
              return;
            }
          } else {
            if (!firstParagraphPasses) {
              if (outlineTop <= mid) {
                if (Math.floor(outlineTop - top) > 2) {
                  // snap back to start of the first paragraph if selection top is less than paragraph mid
                  // setIsErrored(true);
                  if (!isResizing) {
                    setPtop(offsetTop);
                    setOutlineHeight((prev) => prev + (outlineTop - top));
                  }

                  return;
                } else {
                  setIsErrored(false);
                }
              } else {
                if (bottom <= pBottom) {
                  // setIsErrored(true);
                  if (!isResizing) {
                    setPtop(offsetTop);
                    setOutlineHeight((prev) => prev + (outlineTop - top));
                  }
                  return;
                } else {
                  if (i < pElements.length - 1) {
                    const {
                      offsetTop: nTop,
                      dataset: { secid: secidn },
                    } = pElements[i + 1];

                    if (secidn === currentSection) {
                      // setIsErrored(true);
                      if (!isResizing) {
                        setPtop(nTop);
                        setOutlineHeight((prev) => prev - (nTop - pTop));
                      }

                      return;
                    } else {
                      setIsErrored(false);
                    }
                  }
                }
              }
            }

            firstParagraphPasses = true;
          }

          paragraphs.push(id);
        }
      }

      if (prevParagraph && !isResizingUp) {
        const {
          bottom: pBottom,
          top: prTop,
          height: prHeight,
        } = prevParagraph.getBoundingClientRect();
        //snap back to bottom of the last paragraph of the selected section if it exceeds the section from bottom
        const {
          dataset: { secid: prSecId },
        } = prevParagraph;

        /**
         * snap the bottom to the bottom of the current paragraph if the outline is more then 50% down
         * OR
         * also snap the bottom to the bottom of the current paragraph if paragraph top is less or equal to outline top
         **/
        if (outlineTop >= prTop && pBottom - bottom > 5) {
          // setIsErrored(true);
          if (!isResizing) {
            setPtop(pTop);
            setOutlineHeight((prev) => prev + (pBottom - bottom));
          }
          // return;
        } else {
          if ((pBottom - prTop) / 2 + prTop > bottom) {
            // setIsErrored(true);
            if (!isResizing) {
              setPtop(pTop);
              setOutlineHeight((prev) => prev - (bottom - prTop) - 5);
            }
          } else if (pBottom - bottom > 5) {
            // setIsErrored(true);
            if (!isResizing) {
              setPtop(pTop);
              setOutlineHeight((prev) => prev + (pBottom - bottom));
            }
          } else {
            setIsErrored(false);
          }
        }
      }
      if (isSections) {
        setSelectedSections(paragraphs);
      } else {
        setSelectedParagraphs(paragraphs);
      }
    }, 50);

    return () => {
      clearTimeout(timerId.current);
    };
  }, [pTop, outlineHeight, isResizing, isResizingUp, draggedChap, isSections]);

  const scrollableContent = (scroller) => {
    scrollerRef.current = scroller;
  };
  const highlightChapter = (e, value) => {
    setGreyedItem('');
    setHighlightedIndexes([]);
    setGreyedPharagraphs([]);
    if (highlightedSection === value) {
      setHighlightedSection(null);
      setHighlightedSection([]);
      setActivities(book.activities);
    } else {
      if (creatingActivity) return;
      setHighlightedSection(value);
      setActivities(book.activities.filter((e) => e.chapter === value));
      // setScrollToId(value);
    }
  };
  /* Dragging Image, Video, Audio */

  const handleDragStart = (e, type) => {
    e.stopPropagation();
    setIsDraggingFromLeft(true);
    e.dataTransfer.setData('type', type);
    setDraggedType(type);
  };

  const handleDragUpdate = (info) => {
    if (info.destination) {
      const chaptIndex = parseInt(info.destination.droppableId.split('_')[1]);
      const sectionIndex = parseInt(info.destination.droppableId.split('_')[2]);
      const paragraph =
        book.chapters?.[chaptIndex]?.sections?.[sectionIndex]?.paragraphs?.[
          info.destination.index
        ];
      setDraggedType(info.type);
      // setDraggedOverElement(info.draggableId);
      paragraph?._id && setDraggedOverElement(paragraph._id);
    }
  };

  const onHide = useCallback(() => {
    setRemoveItemDetails({
      route: '',
      id: '',
      chapterIndex: -1,
      sectionIndex: -1,
      paragraphIndex: -1,
    });
    setShowModal(false);
    chapterId && setChapterId(null);
    setError('');
  }, [showModal, chapterId, loading]);

  const handleChapterDelete = (
    route,
    id,
    chapterIndex,
    sectionIndex,
    paragraphIndex,
    paragraphType = ''
  ) => {
    setChapterId(id);
    setRemoveItemDetails({
      route,
      id,
      chapterIndex,
      sectionIndex,
      paragraphIndex,
      paragraphType,
    });
    setError('');
    setShowModal(true);
  };

  const removeItem = (e) => {
    e.preventDefault();
    e.persist();
    setLoading(true);

    dispatch(
      deleteBlock({
        id: removeItemDetails.id,
        route: removeItemDetails.route,
        onSuccess: () => {
          switch (removeItemDetails.route) {
            case 'chapter':
              setBook((old) => ({
                ...old,
                chapters: old.chapters.filter((chapter) => chapter._id !== chapterId),
                activities: old.activities.filter((act) => act.chapter !== removeItemDetails.id),
              }));
              dispatch(
                bookActions.setMyBook({
                  ...book,
                  chapters: book.chapters.filter((chapter) => chapter._id !== chapterId),
                  activities: book.activities.filter(
                    (act) => act.chapter !== removeItemDetails.id
                  ),
                })
              );
              break;

            case 'section':
              setBook((old) => {
                const chapters = JSON.parse(JSON.stringify(old.chapters));
                chapters[removeItemDetails.chapterIndex].sections = chapters[
                  removeItemDetails.chapterIndex
                ].sections.filter((section) => section._id !== removeItemDetails.id);
                return {
                  ...old,
                  chapters: chapters,
                  activities: old.activities.filter((act) => act.section !== removeItemDetails.id),
                };
              });
              const updatedChapters = JSON.parse(JSON.stringify(book.chapters));
              updatedChapters[removeItemDetails.chapterIndex].sections = updatedChapters[
                removeItemDetails.chapterIndex
              ].sections.filter((section) => section._id !== removeItemDetails.id);
              dispatch(
                bookActions.setMyBook({
                  ...book,
                  chapters: updatedChapters, // Use 'chapters' instead of 'newChapters'
                  activities: book.activities.filter(
                    (act) => act.section !== removeItemDetails.id
                  ),
                })
              );
              break;

            case 'paragraph':
              setBook((old) => {
                const chapters = JSON.parse(JSON.stringify(old.chapters));

                // Ensure that the chapter exists before accessing sections
                const chapter = chapters[removeItemDetails.chapterIndex];
                if (!chapter) {
                  console.error('Chapter not found at index', removeItemDetails.chapterIndex);
                  return old;
                }

                // Ensure that the section exists before accessing paragraphs
                const section = chapter.sections[removeItemDetails.sectionIndex];
                if (!section) {
                  console.error('Section not found at index', removeItemDetails.sectionIndex);
                  return old;
                }

                // Proceed with paragraph removal if everything exists
                const neParas = section.paragraphs.filter(
                  (para) => para._id !== removeItemDetails.id
                );
                chapters[removeItemDetails.chapterIndex].sections[
                  removeItemDetails.sectionIndex
                ].paragraphs = neParas;
                return {
                  ...old,
                  chapters: chapters,
                  activities: old.activities.map((act) => {
                    if (act.paragraphs.includes(removeItemDetails.id)) {
                      act.paragraphs = act.paragraphs.filter((p) => p !== removeItemDetails.id);
                    }
                    return act;
                  }),
                };
              });
              break;
            default:
              break;
          }

          // Reset state after success
          setRemoveItemDetails({
            route: '',
            id: '',
            chapterIndex: -1,
            sectionIndex: -1,
            paragraphIndex: -1,
          });
          setLoading(false);
          setChapterId(null);
          setShowModal(false);
        },
        onError: (error) => {
          if (error?.response?.data && error?.response?.data?.message) {
            setError(error.response.data.message);
          } else {
            setError('Something went wrong. please try later.');
          }
          setLoading(false);
        },
        onEnd: () => {
          setLoading(false);
        },
      })
    );
  };
  const handleActivityTitleClick = (activityId) => {
    setActivities(book.activities.filter((e) => e?._id === activityId));
  };

  /* ------------------End----------------- */
  return (
    <Fragment>
      <section className='class_room_wrap teach mt-0'>
        <div
          style={{ overflowY: 'clip' }}
          className={`flex-container`}
          onMouseMove={(event) => {
            if (!dragging) return;
            const left = (event.clientX / window.innerWidth) * 100; // percentage of viewport width
            const top = (event.clientY / window.innerHeight) * 100; // percentage of viewport height
            setMousePosition({ x: left, y: top });
          }}
          onMouseUp={(e) => {
            if (isDraggingFromLeft) return;
            if (isResizing) setIsResizing(false);
            e.stopPropagation();
          }}
        >
          <SideBar
            handleActivityTitleClick={handleActivityTitleClick}
            setCurrentTab={setCurrentTab}
            handleChapterDelete={handleChapterDelete}
            book={book}
            handleDragEndAccordion={handleDragEndAccordion}
            handleChapterSelect={handleChapterSelect}
            activeChapter={activeChapter}
            toggleCollapse={toggleCollapse}
            activeIds={activeIds}
            setScrollToId={setScrollToId}
            dropdownRef={dropdownRef}
            handleClick={handleClick}
            isClicked={isClicked}
            isSelectedOption={isSelectedOption}
            handleAddChapter={handleAddChapter}
            setIsClicked={setIsClicked}
            setVisibleSection={setVisibleSection}
            setIsSelectedOption={setIsSelectedOption}
            handleAddSectionClick={() => handleAddSectionClick(true)}
            setBook={setBook}
            addTextBook={addTextBook}
            setAddTextBook={setAddTextBook}
            handleDragStart={handleDragStart}
            currentTab={currentTab}
            setDraggedType={setDraggedType}
            addTextBookButton={addTextBookButton}
          />
          <div style={{ display: 'flex', width: '75%' }}>
            {/* <TextEditor /> */}
            <div className='centre-fold centre-fold-create'>
              <TextEditorFun
                setEditorState={setEditorState}
                editorState={editorState}
                setShowBlock={setShowBlock}
                bookId={bookId}
                setBook={setBook}
                editingOptions={editingOptions}
                setDocumentFocus={setDocumentFocus}
                editableElementRef={editableElementRef}
              />
              <div className={`d-flex ${reverse ? 'reverse' : ''}`}>
                <div
                  className=''
                  style={{
                    marginTop: '64px',
                    paddingRight: '0px',
                    width: '60%',
                  }}
                  onDragOver={handleResizing}
                  onMouseMove={handleResizing}
                >
                  <div
                    style={{
                      position: 'relative',
                      zIndex: '1',
                      height: '50px',
                      padding: '0px 15px',
                      justifyContent: 'space-between',
                      display: 'flex',
                    }}
                    className='parent_subtitle '
                  >
                    {loaders?.bookLoader || !book?.book?._id ? (
                      <>
                        <div className='content-skeleton mb-0 inner-head-load'></div>
                        <div
                          className='content-skeleton mb-0 inner-head-load'
                          style={{ width: '19.6%' }}
                        ></div>
                      </>
                    ) : (
                      <>
                        <div
                          style={{
                            width: '100%',
                            background: '#fff',
                          }}
                          className='main-text'
                        >
                          <div className='center_conter_head_create'>
                            <h1>
                              <b
                                style={{
                                  display: 'inline-block',
                                  overflow: 'hidden',
                                  maxWidth: '150px',
                                  textOverflow: 'ellipsis',
                                  marginBottom: '-2px',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {book.book.title}
                              </b>{' '}
                              | {book.book.author}
                            </h1>
                            <h1>
                              <b>
                                CHAPTER {visibleElements?.chapterOrder || 1}, SECTION{' '}
                                {visibleElements?.sectionOrder || 1}
                              </b>
                            </h1>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  {loaders?.bookLoader || !book?.book?._id ? (
                    <div
                      className={`book chapter_element `}
                      style={{
                        position: 'relative',
                        paddingLeft: '2rem',
                        paddingTop: '4px',
                      }}
                    >
                      <div className='chap-load'>
                        <div
                          className='content-skeleton mb-0 inner-head-load'
                          style={{
                            height: '58px',
                            width: '64%',
                            borderRadius: '4px',
                          }}
                        ></div>
                        <div
                          className='content-skeleton mb-0 inner-head-load'
                          style={{
                            height: '29px',
                            width: '94%',
                            borderRadius: '4px',
                          }}
                        ></div>
                      </div>

                      <div className='' style={{ marginTop: '32px' }}>
                        <div
                          className='content-skeleton  inner-head-load'
                          style={{
                            height: '38px',
                            width: '38%',
                            borderRadius: '4px',
                            marginBottom: '4px',
                          }}
                        ></div>
                        <div
                          className='content-skeleton  inner-head-load'
                          style={{
                            height: '116px',
                            width: '94%',
                            borderRadius: '4px',
                            marginBottom: '32px',
                          }}
                        ></div>
                        <div
                          className='content-skeleton  inner-head-load'
                          style={{
                            height: '319px',
                            width: '94%',
                            borderRadius: '4px',
                            marginBottom: '20px',
                          }}
                        ></div>
                        <div
                          className='content-skeleton  inner-head-load'
                          style={{
                            height: '290px',
                            width: '94%',
                            borderRadius: '4px',
                          }}
                        ></div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className='center_content'
                      style={{
                        height: 'calc(99vh - 96px)',
                        marginRight: '0px',
                      }}
                      id='scrollablecontent'
                      ref={scrollableContent}
                      onMouseMove={handleResizing}
                    >
                      <div className='center_conter_chapter  ' style={{ overflowX: 'hidden' }}>
                        {/* For add chapter and section */}
                        <DragDropContext
                          onDragUpdate={handleDragUpdate}
                          onDragEnd={handleDragEndChapters}
                          shouldUseVirtualForLargeElements={true}
                          className='droppable-container'
                        >
                          <div
                            className='d-flex w-100 align-items-end'
                            style={{ height: '25px' }}
                            onDrop={handleTopDrop}
                            onDragOver={(e) => {
                              e.preventDefault();

                              setDraggedOverElement('top_most');
                            }}
                          >
                            <div
                              className={
                                draggedOverElement === 'top_most' && draggedType === 'chapter'
                                  ? 'dragged_indicator'
                                  : 'dragged_indicator_transparent'
                              }
                              id='indicator'
                            ></div>
                          </div>
                          <Droppable droppableId='chapters' type='chapter'>
                            {(provided, snapshot) => (
                              <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className={snapshot.isDraggingOver ? 'is-dragging' : ''}
                              >
                                {book.chapters.map((chap, chapInd) => (
                                  <Chapter
                                    isErrored={isErrored}
                                    key={`chapter_${chapInd}`}
                                    onVisibilityChange={handleVisibilityChange}
                                    fontLarge={settings.fontLarge}
                                    book={book}
                                    setBook={setBook}
                                    setActivities={setActivities}
                                    highlightedSection={highlightedSection}
                                    setHighlightedSections={setHighlightedSections}
                                    greyedItem={greyedItem}
                                    highlightedSections={highlightedSections}
                                    setGreyedItem={setGreyedItem}
                                    draggedOver={draggedOver}
                                    setDraggedOver={setDraggedOver}
                                    highlightedIndexes={highlightedIndexes}
                                    isSections={isSections}
                                    setHighlightedIndexes={setHighlightedIndexes}
                                    draggedChap={draggedChap}
                                    pTop={pTop}
                                    outlineHeight={outlineHeight}
                                    isResizing={isResizing}
                                    greyedParagraphs={greyedParagraphs}
                                    setGreyedPharagraphs={setGreyedPharagraphs}
                                    highlightedParagraph={highlightedParagraph}
                                    setHighlightedParagraph={setHighlightedParagraph}
                                    draggedType={draggedType}
                                    draggedOverElement={draggedOverElement}
                                    showBlock={showBlock}
                                    setShowBlock={setShowBlock}
                                    mediaList={mediaList}
                                    setMediaList={setMediaList}
                                    handleDragLeave={handleDragLeave}
                                    setEditableElement={setEditableElement}
                                    handleChapterDrop={handleChapterDrop}
                                    handleSectionDrop={handleSectionDrop}
                                    handleParagraphDrop={handleParagraphDrop}
                                    handleAddChapter={handleAddChapterBlock}
                                    handleDragOver={handleDragOver}
                                    highlightSection={highlightSection}
                                    dynamicSectionStyles={dynamicSectionStyles}
                                    resizingSet={resizingSet}
                                    dynamicPStyles={dynamicPStyles}
                                    highlightChapter={highlightChapter}
                                    handleChapterDelete={handleChapterDelete}
                                    chap={chap}
                                    chapInd={chapInd}
                                    handleAddSection={handleAddSection}
                                    handleAddMediaBlock={handleAddMediaBlock}
                                    handleAddSectionBlock={handleAddSectionBlock}
                                    handleAddChapterSubBlock={handleAddChapterSubBlock}
                                    handleAddSmallHeaderBlock={handleAddSmallHeaderBlock}
                                  ></Chapter>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                        {!book.chapters.length && (
                          <h4
                            className='min_title_create'
                            style={{
                              marginLeft: '2.5rem',
                              marginBottom: '0px',
                              color: '#76736F',
                            }}
                          >
                            Add a chapter to get started
                          </h4>
                        )}
                        <div
                          className='add_btn_Wrap'
                          style={{
                            marginLeft: '2.5rem',
                            marginTop: '2rem',
                          }}
                        >
                          <button
                            type='button'
                            className='add_btn_theme'
                            onClick={() => {
                              handleAddChapter();
                              setVisibleSection(true);
                            }}
                          >
                            <img src={close} alt='close' />
                            Add chapter
                          </button>
                          {book.chapters.length > 0 && (
                            <button
                              type='button'
                              className='add_btn_theme'
                              onClick={() => {
                                handleAddSectionClick();
                              }}
                            >
                              <img src={close} alt='close' />
                              Add section
                            </button>
                          )}
                          {book.chapters.length > 0 &&
                            book.chapters[book.chapters.length - 1].sections &&
                            book.chapters[book.chapters.length - 1].sections.length > 0 && (
                              <button
                                type='button'
                                className='add_btn_theme'
                                onClick={() => {
                                  handleAddParagraph(
                                    book.chapters[book.chapters.length - 1],
                                    book.chapters[book.chapters.length - 1].sections[
                                      book.chapters[book.chapters.length - 1].sections.length - 1
                                    ],
                                    book.chapters.length - 1,
                                    book.chapters[book.chapters.length - 1].sections.length - 1
                                  );
                                }}
                              >
                                <img src={close} alt='close' />
                                Add paragraph
                              </button>
                            )}
                        </div>
                      </div>
                      <div className='bottom_button_wrap'>
                        <button type='button' className='btn_white_outline'>
                          Save changes
                        </button>
                        <button type='button' className='btn_white_outline'>
                          Push changes to class
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className=''
                  style={{
                    marginTop: '70px',
                    paddingLeft: '0px',
                    width: '40%',
                  }}
                >
                  <RightBar
                    mode={'create'}
                    newActivities={newActivities}
                    setSelectedParagraphs={setSelectedParagraphs}
                    selectedParagraphs={selectedParagraphs}
                    setSelectedSections={setSelectedSections}
                    selectedSections={selectedSections}
                    setNewActivities={setNewActivities}
                    setDraggedType={setDraggedType}
                    setHighlightedParagraph={setHighlightedParagraph}
                    setHighlightedSection={setHighlightedSection}
                    setGreyedItem={setGreyedItem}
                    setGreyedPharagraphs={setGreyedPharagraphs}
                    creatingActivity={creatingActivity}
                    writingActivity={writingActivity}
                    setCreatingActivity={setCreatingActivity}
                    setWritingActivity={setWritingActivity}
                    setDraggedOver={setDraggedOver}
                    setHighlightedIndexes={setHighlightedIndexes}
                    draggedChap={draggedChap}
                    dragging={dragging}
                    mousePosition={mousePosition}
                    draggedActivity={''}
                    isDraggingActivity={() => {}}
                    setDraggedActivity={() => {}}
                    greyedItemSetter={() => {}}
                    draggedActivityPosition={{}}
                    setMousePosition={setMousePosition}
                    showCalendar={undefined}
                    setReverse={setReverse}
                    reverseIt={reverseIt}
                    reverse={reverse}
                    activities={activities}
                    setActivitySetModal={() => {}}
                    setDraggedActivityPosition={() => {}}
                    setDragging={setDragging}
                    setIsDraggingActivity={() => {}}
                    scrollTo={scrollTo}
                    setDraggedChap={setDraggedChap}
                    hitBottom={handleResizing}
                    bookId={bookId}
                    activityElement={activityElement}
                    setActivityElement={activityElement}
                    showClearBtn={
                      greyedParagraphs?.length > 0 ||
                      greyedItem ||
                      highlightedSection ||
                      highlightedSections.length > 0
                    }
                    onClear={() => {
                      setGreyedPharagraphs([]);
                      setHighlightedIndexes([]);
                      setHighlightedParagraph(null);
                      setHighlightedSection('');
                      setGreyedItem('');
                      setDraggedOver(null);
                      setActivities(book.activities);
                      setSelectedParagraphs([]);
                      setSelectedSections([]);
                      setHighlightedSections([]);
                    }}
                    activityFilter={rightBarRef.current?.handleActivityFilter}
                    ref={rightBarRef}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ModalPortal>
        <CustomModal
          error={error}
          onHide={onHide}
          is_delete={true}
          loading={loading}
          showModal={showModal}
          onAction={removeItem}
          cancelBtnText='Go Back'
          title={`delete this ${removeItemDetails.paragraphType || removeItemDetails.route}?`}
          actionBtnText={`Delete ${removeItemDetails.paragraphType || removeItemDetails.route}`}
          content={`Are you sure you want to delete this ${
            removeItemDetails.paragraphType || removeItemDetails.route
          } from the book? This can not be undone and all changes will be lost. If you created any activities that are associated with this ${
            removeItemDetails.paragraphType || removeItemDetails.route
          }, they will be deleted.`}
        />
      </ModalPortal>
    </Fragment>
  );
};
